import axiosPrivate from "@services/axiosPrivate";
// import { UPDATE_PRICE_URL } from "src/constants";

export const updatePrice = (priceId,doctorObject) => {
    return axiosPrivate.put(`/updatePrice/${priceId}`, doctorObject);
}